import React from 'react';

import { Avatar, Button, Group, Paper, Text } from '@mantine/core';
import { getAvatarColor } from 'utils/colors';

import type { AthleteCalendarAthlete } from './types';

interface AthleteInfoBarProps {
  athlete: AthleteCalendarAthlete;
  onOpenProfile: () => void;
  onAssignWorkout?: () => void;
}

const AthleteInfoBar = ({ athlete, onOpenProfile, onAssignWorkout }: AthleteInfoBarProps): JSX.Element => {
  const initials = `${athlete.firstName?.[0] ?? ''}${athlete.lastName?.[0] ?? ''}`.toUpperCase();

  return (
    <Paper px='md' py='sm' radius={0} data-cy='athleteInfoBar'>
      <Group position='apart' noWrap>
        <Group spacing='sm' noWrap>
          <Avatar radius='xl' src={athlete.profilePicture} color={getAvatarColor(athlete.athleteId)}>
            {initials}
          </Avatar>
          <Text
            fw={700}
            td='underline'
            sx={{ cursor: 'pointer' }}
            onClick={onOpenProfile}
            data-cy='athleteInfoBarName'
          >
            {athlete.fullName}
          </Text>
        </Group>
        {onAssignWorkout && (
          <Button color='kiloBlue' onClick={onAssignWorkout} data-cy='athleteInfoBarAssign'>
            Assign Workout
          </Button>
        )}
      </Group>
    </Paper>
  );
};

export default AthleteInfoBar;
